import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of, map, catchError } from 'rxjs';
import { GlobalService } from '../../services/global.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyDetailsAccessGuard implements CanActivate {
  constructor(
    private router: Router,
    private globalService: GlobalService,
  ) {}

  canActivate(): Observable<boolean> {
    const token = sessionStorage.getItem('accessToken');

    if (!token) {
      this.router.navigate(['/auth']);
      return of(false);
    }

    return this.globalService.whoAmI(token).pipe(
      map((res) => {
        // const isCompanyDetailSubmitted =
        //   res.body?.isAuthorizedPersonDetailSubmitted;
        const isCompanyDetailSubmitted =
          Array.isArray(res.body?.accountsMainCategories) &&
          res.body.accountsMainCategories.length === 0 &&
          res.body?.isAssociate;
        if (isCompanyDetailSubmitted === false) {
          return true;
        } else {
          this.router.navigate(['/auth']);
          return false;
        }
      }),
      catchError((err) => {
        console.error('Error fetching user info', err);
        this.router.navigate(['/auth']);
        return of(false);
      }),
    );
  }
}
